import {Box, Typography} from '@mui/material';
import { GOLD_BOX_STATUS } from '../../utils/constants';
import Badge from '../base/BaseBadge/BaseBadge';
import {useTheme} from '@mui/material';
import { miliToGram, numberToTomans } from '../../utils/helpers';

const PureGoldItem = ({ item }) => {

    const theme = useTheme();
    const getBadgeProps = (status) => {
        return { type: GOLD_BOX_STATUS[status].type, text: GOLD_BOX_STATUS[status].title }
    };

    const badgeProps = getBadgeProps(item.status);
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: 350,
                height: 200,
                borderRadius: 3,
                padding: '10px',
                margin: '12px',
                background: theme.gradients.background,
                boxShadow: 'none',
            }}
        >
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "12px",
                    width: "30%"
                }}
            >
                <Typography variant="caption2">
                    {`طلای آب شده`}
                </Typography>
                <Typography variant="subtitle2">
                    {`وزن: ${miliToGram(item.goldWeight)} گرم`}
                </Typography>
            </Box>
            <Box 
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    padding: "24px 0",
                    alignItems: "center",
                    gap: "8px",
                    width: "30%"
                }}
            >
                <Typography variant="subtitle" color="textPrimary">
                    {`${numberToTomans(item.value)} تومان`}
                </Typography>
                <Badge {...badgeProps} />
                
            </Box>
        </Box>
    );
};

export default PureGoldItem;
